module.exports = __webpack_public_path__ + "media/evolve/assets/icons/static/import-5bace81e94d4840796c95d8c322b1f2b.svg";